import { render, staticRenderFns } from "./QuestionTemplateAddPage.vue?vue&type=template&id=5b2e919d&scoped=true&"
import script from "./QuestionTemplateAddPage.vue?vue&type=script&lang=ts&"
export * from "./QuestionTemplateAddPage.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionTemplateAddPage.vue?vue&type=style&index=0&id=5b2e919d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2e919d",
  null
  
)

export default component.exports